import React, { Component } from 'react'
import Popover from '../ui/Popover'
import { push } from '../../history'

export default class extends Component {
  showPopover = (e) => {
    e.preventDefault()
    this.popover.setState({showing: true, target: e.target})
  }

  new = (e) => {
    e.preventDefault()
    this.popover.setState({showing: false})
    push(`${document.location.pathname}/new`)
  }

  render () {
    return <div className='nothing'>
      <h1>Create something</h1>
      <p>
        Use the <a onClick={this.showPopover}><i className='ion-ios-plus-outline' /></a> to get started.
      </p>
      <Popover
        ref={c => (this.popover = c)}
        className='popover-menu'
      >
        <a onClick={this.new}>New content type</a>
      </Popover>
    </div>
  }
}



// WEBPACK FOOTER //
// ./app/components/help/NoTypes.js